import { render, staticRenderFns } from "./PickupSetup.vue?vue&type=template&id=66f4bcaf&"
import script from "./PickupSetup.vue?vue&type=script&lang=js&"
export * from "./PickupSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports